import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl/dist';

// Components

import Form from '../../../lib/wrappers/Form';
import UniversalInput from '../../../lib/wrappers/UniversalInput';

// ActionCreators

import { changeData } from '../../../actions/ssap/ssapActionCreators';

// Utils

import { currencyTools } from '../../../utils/tools/currencyTools';
import { normalizeNameOfPerson } from '../../../utils/normalize/normalizeNameOfPerson';

// Constants

import { INPUT_TYPES } from '../../../constants/inputs/inputTypes';
import { DROPDOWN_OPTIONS } from '../../../constants/ssap/hhmTypes/dropdownOptions';
import { VALIDATION_TYPES } from '../../../constants/inputs/validationTypes';
import { VALIDATION_ERROR_MESSAGES } from '../../../constants/inputs/validationErrorMessages';



const Page3_35_E1 = props => {

    const {
        data,
        data: {
            coverageYear
        },
        formName,
        householdMembers,
    } = props;

    const {
        hhmIndex : member,
        currentHhm
    } = props;

    const {
        annualTaxIncome:{
            reportedIncome,
            projectedIncome,
            unknownIncome,
            variableIncome
        },
        name
    } = currentHhm;

    const onFieldChange = (...args) => {
        const [ newData, , , [ name, value ] ] = args;

        if(name === 'variableIncome') {
            newData.annualTaxIncome.projectedIncome = value ? 0 : projectedIncome;
            newData.annualTaxIncome.unknownIncome = null;
        }

        if(name === 'unknownIncome') {
            newData.annualTaxIncome.projectedIncome = 0;
        }

        const newState = { ...data };
        newState.taxHousehold.householdMember[member] = newData;
        props.actions.changeData(newState);
    };

    const checkTopLevelValidation = () => {
        if(variableIncome === false) {
            return !!projectedIncome;
        }
        return true;
    };

    const replacements = {
        personName: (
            <strong>
                { normalizeNameOfPerson(name) }
            </strong>
        ),
        coverageYear: (
            <strong>
                { coverageYear }
            </strong>
        )
    };

    return (
        <div
            className = 'fade-in'
            id = 'iiExpectedIncom'
        >
            <div className = 'subsection' >
                <Form
                    topLevelValidity={checkTopLevelValidation()}
                    { ...{ formName } }
                >
                    <UniversalInput
                        legend = { {
                            legendText: 'ssap.input.legend.variable_income',
                            legendTextReplacements: {
                                personName: (
                                    <strong>
                                        { normalizeNameOfPerson(name) }
                                    </strong>
                                ),
                                reportedIncome: (
                                    <strong>
                                        {
                                            reportedIncome === 0
                                                ? '$0.00'
                                                : currencyTools.getMoneyFormat(reportedIncome, true)
                                        }
                                    </strong>
                                ),
                                coverageYear: (
                                    <strong>
                                        { coverageYear }
                                    </strong>
                                )
                            }
                        } }
                        label = { {
                            ulClass: [ 'margin-b-20' ],
                            showRequiredIcon: true
                        } }
                        inputData = { {
                            isInputRequired: true,
                            type: INPUT_TYPES.RADIO_BUTTONS,
                            classes: [ 'disp-styl-none' ],
                            name: 'variableIncome',
                            value: variableIncome,
                            options: DROPDOWN_OPTIONS.YES_NO,
                            validationType: VALIDATION_TYPES.CHOSEN,
                            currentData: householdMembers[member],
                            fields: [ 'annualTaxIncome' ]
                        } }
                        inputActions = { {
                            onFieldChange
                        } }
                        errorClasses = { [ 'margin-l-0' ] }
                    />

                    {
                        variableIncome === false &&

                        <Fragment>
                            <p className = 'required-true' >
                                <FormattedMessage
                                    id = 'ssap.income_information.expected_income.projected_income'
                                    values = { replacements }
                                />
                            </p>

                            {
                                !unknownIncome &&

                                <UniversalInput
                                    label = { {
                                        text: 'ssap.input.label.total_year_amount',
                                        labelClasses: [ 'tablet:grid-col-4' ]
                                    } }
                                    inputData = { {
                                        isInputRequired: false,
                                        type: INPUT_TYPES.MONEY_INPUT,
                                        name: 'projectedIncome',
                                        value: projectedIncome,
                                        isOnlyPositiveAvailable: true,
                                        inputClasses: [ 'tablet:grid-col-6' ],
                                        validationType: VALIDATION_TYPES.MONEY,
                                        placeholder: 'ssap.input.placeholder.amount',
                                        validationErrorMessage: VALIDATION_ERROR_MESSAGES.DOLLAR,
                                        currentData: householdMembers[member],
                                        fields: [ 'annualTaxIncome' ]
                                    } }
                                    inputActions = { {
                                        onFieldChange
                                    } }
                                />
                            }

                            <UniversalInput
                                label = { {
                                    text: 'ssap.input.label.do_not_know'
                                } }
                                inputData = { {
                                    isInputRequired: false,
                                    type: INPUT_TYPES.CHECKBOX,
                                    name: 'unknownIncome',
                                    classes: [ 'layout--01' ],
                                    checked: unknownIncome,
                                    value: unknownIncome,
                                    currentData: householdMembers[member],
                                    fields: [ 'annualTaxIncome' ]
                                } }
                                inputActions = { {
                                    onFieldChange
                                } }
                            />
                        </Fragment>
                    }

                    {
                        unknownIncome &&

                        <Fragment>
                            <FormattedMessage
                                id = 'ssap.income_information.expected_income.estimation'
                                values = { replacements }
                                tagName = 'p'
                            />
                            <UniversalInput
                                label = { {
                                    text: 'ssap.input.label.total_year_amount',
                                    labelClasses: [ 'tablet:grid-col-4' ]
                                } }
                                inputData = { {
                                    isInputRequired: true,
                                    type: INPUT_TYPES.MONEY_INPUT,
                                    name: 'projectedIncome',
                                    value: projectedIncome,
                                    isOnlyPositiveAvailable: true,
                                    inputClasses: [ 'tablet:grid-col-6' ],
                                    validationType: VALIDATION_TYPES.MONEY,
                                    placeholder: 'ssap.input.placeholder.amount',
                                    currentData: householdMembers[member],
                                    fields: [ 'annualTaxIncome' ]
                                } }
                                inputActions = { {
                                    onFieldChange
                                } }
                            />
                        </Fragment>
                    }
                </Form>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data,

    householdMembers: state
        .ssap
        .data
        .taxHousehold
        .householdMember
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Page3_35_E1);
